/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MetricsFiltersGated } from './metricsFiltersGated';

/**
 * Filters for GET /reports/metrics (echoed without metric names).
 */
export interface MetricsFilters {
  /** Inclusive range start (ISO datetime) */
  from: string;
  /** Exclusive range end (ISO datetime) */
  to: string;
  gated: MetricsFiltersGated;
  excludePasteHeavy: boolean;
  excludeFirstTryPasses: boolean;
}
